import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProcesswireComponent } from './simple-icons-processwire.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProcesswireComponent ],
    exports:      [ SimpleIconsProcesswireComponent ],
    bootstrap:    []
})
export class SimpleIconsProcesswireModule {}
